import React from 'react';
import { Divider, Form } from '@roo/roo';
import styled from 'styled-components';
import { saveApplyInfo } from '@assets/apis/innovate';
import { Person } from './person';
import { Project } from './project';
import { Info } from './info';
import { Detail, stageArr } from './detail';
import { Budget } from './budget';
import { Seal } from './seal';
import { Participant } from './participant';
import { cols } from '../../_utils/config';
import { useSimpleContext } from '../../_context';
import { FormHok } from '../../_components/FormHok';

const Root = styled.div`
  .form-patch {
    margin-top: 8px;
    width: 634px;
  }
  .form-group {
    & > label {
      text-align: left;
    }
  }
  .boffin {
    position: relative;
    .delete {
      position: absolute;
      top: -10px;
      right: 100px;
    }
  }
  .roo-radio-group {
    font-size: 14px;
  }
  .prefix-w {
    ::after {
      content: '万元';
      position: relative;
      right: 24px;
    }
  }
  .prefix-a {
    ::after {
      content: '平方米';
      position: relative;
      right: 36px;
    }
  }
  .apply-area {
    height: 120px;
  }
  .cert-table {
    display: grid;
    grid-template-columns: repeat(3, auto);
    border: 1px solid #eee;
    grid-gap: 1px;
    background-color: #eee;
    width: 660px;
    //height: 300px;
    div {
      background-color: #fff;
      padding: 0 4px;
    }
    .c-title {
      background: #fafafa;
      text-align: center;
      height: 40px;
      display: inline-block;
      line-height: 40px;
    }
    .c-task,
    .c-achievement,
    .c-time {
      height: 111px;
      display: inline-block;
      line-height: 111px;
      text-align: center;
      width: 282px;
    }
    .c-time {
      width: 92px;
    }
    .c-task,
    .c-achievement {
      .c-area {
        height: 80%;
        width: 100%;
        border: 0;
        padding: 6px;
      }
    }
  }
  .budget-table {
    margin: 0 !important;
    padding: 0 !important;
    input {
      width: 220px;
    }
    .suffix-input {
      ::after {
        content: '¥';
        position: relative;
        right: 0;
      }
    }
    .form-group {
      margin-bottom: 0;
    }
    .delete {
      right: -100px;
    }
  }
`;

const applyData = {
  name: '',
  job: '',
  phone: '',
  email: '',
  reportDirection: 1, //申报方向id,单选
  applyFile: '',
  officialSealUrl: [],
};

// 申报信息
export const ApplyInfo = function ({ setStep }) {
  const { state } = useSimpleContext((t) => [t.innovate.iniValues, t.disabled]);
  const disabled = state.disabled;
  const iniData = state.innovate.iniValues?.applyInfo;
  return (
    <FormHok
      value={iniData || { ...applyData }}
      disabled={disabled}
      cols={cols}
      alwaysUpdate={false}
      handleSave={(val) => {
        if (val?.stages) {
          val.stages.map((item, index) => {
            item.time = stageArr[index];
          });
        }
        // if (val?.officialSealUrl) {
        //   val.officialSealUrl = [val.officialSealUrl];
        // }
        return saveApplyInfo(val);
      }}
    >
      {(props) => (
        <Root className="boffin">
          <div className="form-title">
            申报主要联系人信息
            <span className="sub-title-inline">后续若进入终审环节，将通知申报主要联系人</span>
            <Divider />
          </div>
          <Person {...props} />
          <div className="form-title">
            项目基本信息
            <Divider />
          </div>
          <Info {...props} />
          {/* <div className='form-title'>
              项目详情
              <Divider />
            </div>
            <Detail {...props} />
            <div className='form-title'>
              项目负责人及主要参与人员
              <Divider />
            </div>
            <Participant {...props} /> */}
          <div className="form-title">
            项目预算
            <Divider />
          </div>
          <Budget {...props} />
          <div className="form-title">
            项目申报书
            <Divider />
          </div>
          <Seal {...props} />
          {/* <div className='form-title'>
              项目申报
              <Divider />
            </div>
            <Project {...props} /> */}
        </Root>
      )}
    </FormHok>
  );
};
